import { BaseSkeleton } from 'components/BaseSkeleton'
import BreadCrumbs from 'components/BreadCrumbs'

import type { IDashboardFolderHeader } from './dashboard-folder-header.types'
import './dashboard-folder-header.styles.scss'

export const DashboardFolderHeaderView = ({ breadCrumbs, loading }: IDashboardFolderHeader) => {
  if (loading) {
    return (
      <div className="DashboardFolderHeader">
        <BaseSkeleton height="20px" width="90px" />
        <BaseSkeleton height="30px" width="150px" />
      </div>
    )
  }

  return (
    <div className="DashboardFolderHeader">
      <BreadCrumbs breadcrumbs={breadCrumbs} />
    </div>
  )
}
